import { render, staticRenderFns } from "./mainHeader.vue?vue&type=template&id=1fbf3718&scoped=true&"
import script from "./mainHeader.vue?vue&type=script&lang=js&"
export * from "./mainHeader.vue?vue&type=script&lang=js&"
import style0 from "./mainHeader.vue?vue&type=style&index=0&id=1fbf3718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf3718",
  null
  
)

export default component.exports